import { getRequestConfig } from './';

export const doGetPaymentPlanInfo = () => {
  const config = getRequestConfig();
  return fetch(
    `/json/app/epayment/getpaymentinfo/plan/`,
    Object.assign({}, { method: 'POST', body: JSON.stringify({}) }, config),
  );
};
